import { action, createContextStore } from 'easy-peasy'
import { createQuestionModel } from './models/question'
import { createResultModel } from './models/result'
import { createShortcutsModel } from './models/shortcuts'
import { createSignUpModel } from './models/signUp'
import { createGeneralModel } from './models/general'
import { createUIModel } from './models/ui'

const AppStore = createContextStore(runtimeModel => runtimeModel, { name: 'AppStore' })

export const createAppModel = (initialData, component) => ({
	general: createGeneralModel(initialData, component),
	ui: createUIModel(),
	question: createQuestionModel(initialData),
	result: createResultModel(initialData),
	shortcuts: createShortcutsModel(initialData),
	signUp: createSignUpModel(initialData, component),
	tokens: _.cloneDeep(initialData.tokens || {}),
	scoreTiers: _.cloneDeep(initialData.score_tiers || []),
	updateTokens: action((state, payload) => {
		state.tokens = {
			...state.tokens,
			...payload,
		}
	}),
})

export default AppStore
